var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import cx from 'classnames';
import Component from '@arco-design/web-react/es/Progress';
import { useConfigContext } from '../config-provider';
var Progress = function (props, ref) {
    var className = props.className;
    var common = useConfigContext().prefixCls;
    var prefixCls = common + "-progress";
    return React.createElement(Component, __assign({ ref: ref, className: cx(className, prefixCls) }, props));
};
export default React.forwardRef(Progress);
//# sourceMappingURL=index.js.map